//手风琴
var accor = function (acc, wd, speed) {
  setTimeout( function () {
    var $accor = acc;
    var accorImg = $accor.find(".img_ar img");
    var backImgs = $("#thirdlBackgroundImg").children();
  
    function setBackImgsAn(idx) {
      $(backImgs.toArray()[idx])
        .stop(true)
        .animate({ opacity: 1 }, 300)
        .siblings()
        .stop(true)
        .animate({ opacity: 0 }, 300);
    }
  
    var accorSet = function () {
      var wdC = 548;
      var $accorLiWidth = 160;
      var $accorLi = $accor.find("li");
      var wdParent;
      var patt1 = new RegExp(/^\d+%$/);
      var isPatt = patt1.test(wd);
      var perc = 0;
      if (isPatt) {
        perc = wd.replace("%", "");
      }
      var widSetInit = function () {
        wdParent = $accor.width();
        if (isPatt) {
          wd = (parseInt(wdParent) * perc) / 100;
        }
  
        $accorLi.find(".img_ar").css({ width: wdC });
        $accorLi.css({ width: $accorLiWidth });
  
        setTimeout(function () {
          $accor.css({ height: $accor.height() });
          $accorLi.find(".img_ar").css({ height: $accor.height() });
        }, 200);
      };
      widSetInit();
      $(window).resize(function () {
        $accor.css({ height: "auto" });
        $accorLi.find(".img_ar").css({ height: "auto" });
        widSetInit();
      });
  
      $accor.addClass("accorNoClick");
      $accorLi.hover(
        function () {
          let idx = $(this).index();
          setBackImgsAn(idx)
          $(this)
            .addClass("cur")
            .stop(true)
            .animate({ width: wdC }, speed)
            .siblings()
            .removeClass("cur")
            .stop(true)
            .animate({ width: $accorLiWidth }, speed);
        },
        function () {
          setBackImgsAn(0)
          $accorLi
            .stop(true)
            .animate({ width: $accorLiWidth }, speed)
            .removeClass("cur");
        }
      );
    };
    // 判断图片加载的函数
    var accrIsImgLoad = function (_obj) {
      if (_obj.height() === 0) {
        var t_img;
        t_img = setInterval(function () {
          clearInterval(t_img);
          accrIsImgLoad(_obj);
        }, 10);
      } else {
        accorSet(_obj);
      }
    };
  
    for (var i = 0; i < accorImg.length; i++) {
      var accrImg = $(accorImg[i]);
      var newImg = new Image();
      newImg.index = i;
      accrIsImgLoad($(accorImg[i]));
      newImg.src = accrImg.attr("src");
    }
  },1000)
};

export default accor;
